import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  toggle(event) {
    const row = event.currentTarget.closest("[data-expandable-list-target='row']")
    const open = !row.classList.contains("expandable-row--open")

    this.rowTargets.forEach((target) => this.setOpen(target, target === row && open))
  }

  setOpen(row, open) {
    row.classList.toggle("expandable-row--open", open)
    row.querySelector(".expandable-row__toggle").setAttribute("aria-expanded", open)
  }
}
